// frontend/src/pages/ProfilePage.js
import React, { useState, useEffect } from 'react'; // Eliminado useContext
import api from '../services/api';
import { defaultAvatars } from '../services/avatars';
// import { useNavigate } from 'react-router-dom'; // Eliminado si no se usa

function ProfilePage() {
    // --- CORRECCIÓN: Obtener 'user' de sessionStorage ---
    const [user, setUser] = useState(null); // Estado local para datos del usuario
    // --- FIN CORRECCIÓN ---

    const [formData, setFormData] = useState({
        nombre_completo: '',
        bio: '',
        telefono: '',
        carrera: '',
        facultad_id: '',
        avatar_url: '',
        email: '' // Añadido email al formData
    });

    const [universidades, setUniversidades] = useState([]);
    const [selectedUniversidadId, setSelectedUniversidadId] = useState('');
    const [facultades, setFacultades] = useState([]); // Necesitamos cargar facultades basado en la universidad
    const [selectedAvatar, setSelectedAvatar] = useState('');

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    // const navigate = useNavigate(); // Eliminado si no se usa

    useEffect(() => {
        const loadData = async () => {
            try {
                setLoading(true);
                setError('');

                // Cargar universidades PRIMERO
                const universidadesResponse = await api.get('/general/universidades');
                const uniData = universidadesResponse.data;
                setUniversidades(uniData);

                // Cargar datos del usuario desde /me
                const userResponse = await api.get('/users/me');
                const userData = userResponse.data;
                setUser(userData); // Guardar datos completos del usuario en estado local
                setSelectedAvatar(userData.avatar_url || defaultAvatars[0]);

                let currentUniId = '';
                let currentFacId = '';
                if (userData.facultad) {
                    currentFacId = userData.facultad.id;
                    // Encontrar la universidad de esa facultad
                    for (const uni of uniData) {
                        if (uni.facultades.some(fac => fac.id === currentFacId)) {
                            currentUniId = uni.id;
                            break;
                        }
                    }
                }

                // Cargar facultades si se encontró la universidad
                if (currentUniId) {
                    setSelectedUniversidadId(String(currentUniId));
                    const currentUni = uniData.find(u => u.id === currentUniId);
                    if (currentUni) {
                        setFacultades(currentUni.facultades);
                    }
                } else {
                     setFacultades([]); // Limpiar facultades si no hay universidad
                }

                // Establecer datos del formulario
                setFormData({
                    nombre_completo: userData.nombre_completo || '',
                    bio: userData.bio || '',
                    telefono: userData.telefono || '',
                    carrera: userData.carrera || '',
                    facultad_id: currentFacId ? String(currentFacId) : '',
                    avatar_url: userData.avatar_url || defaultAvatars[0],
                    email: userData.email || '' // Guardar email en formData
                });

            } catch (err) {
                setError('Error al cargar los datos del perfil.');
                console.error("Error cargando datos:", err);
                if (err.response && err.response.status === 401) {
                    // Si es error de autenticación, limpiar sessionStorage y redirigir (opcional)
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('user');
                    window.dispatchEvent(new Event('storage'));
                    // navigate('/login'); // Descomentar si quieres redirigir
                }
            } finally {
                setLoading(false);
            }
        };
        loadData();
    }, []); // Ejecutar solo una vez al montar

    // Efecto para actualizar facultades cuando cambia la universidad seleccionada
    useEffect(() => {
        if (selectedUniversidadId) {
            const universidad = universidades.find(u => u.id === parseInt(selectedUniversidadId));
            setFacultades(universidad ? universidad.facultades : []);
        } else {
            setFacultades([]);
        }
    }, [selectedUniversidadId, universidades]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleUniversidadChange = (e) => {
        const uniId = e.target.value;
        setSelectedUniversidadId(uniId);
        // Resetear facultad al cambiar universidad
        setFormData((prev) => ({
            ...prev,
            facultad_id: '',
        }));
    };

    const handleAvatarClick = (avatarUrl) => {
        setSelectedAvatar(avatarUrl);
        setFormData((prev) => ({
            ...prev,
            avatar_url: avatarUrl,
        }));
    };

    const handleDataSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setLoading(true); // Indicar que estamos guardando

        try {
            const payload = {
                ...formData,
                facultad_id: formData.facultad_id ? parseInt(formData.facultad_id) : null,
                // El email no se debería poder cambiar aquí usualmente, pero lo incluimos si está en formData
            };
            // Eliminar email del payload si no quieres permitir su cambio
            // delete payload.email;

            const response = await api.put('/users/me/editar-perfil', payload);

            // --- CORRECCIÓN: Actualizar user local y sessionStorage ---
            setUser(response.data); // Actualizar estado local
            sessionStorage.setItem('user', JSON.stringify(response.data)); // Actualizar sesión
            window.dispatchEvent(new Event('storage')); // Notificar a otros componentes (Navbar)
            // --- FIN CORRECCIÓN ---

            setSuccess('¡Perfil actualizado con éxito!');
        } catch (err) {
            setError(err.response?.data?.detail || 'Error al guardar el perfil.');
        } finally {
            setLoading(false); // Terminar indicación de guardado
        }
    };

    if (loading && !user) return <div className="text-center p-5">Cargando perfil...</div>;
    // Mostrar error si no se pudo cargar el usuario inicial
    if (!user && error) return <div className="alert alert-danger">{error}</div>;
    // Si user es null pero no hay error y no está cargando, es raro, pero mostramos algo
    if (!user) return <div className="alert alert-warning">No se pudo cargar el perfil del usuario.</div>;

    return (
        <div className="row g-4">
            {/* Columna de Avatar */}
            <div className="col-md-4">
                <div className="card shadow-sm border-0 sticky-top" style={{ top: '20px' }}>
                    <div className="card-body text-center p-4">
                        <img
                            src={selectedAvatar || defaultAvatars[0]}
                            alt="Avatar"
                            className="img-fluid rounded-circle mb-3 shadow"
                            style={{ width: '150px', height: '150px', objectFit: 'cover', border: '3px solid white' }}
                        />
                        <h5 className="card-title mb-1">{user.username}</h5>
                        <p className="text-muted small mb-3">{user.email}</p>
                        <hr />
                        <p className="text-muted small mb-2">Elige un avatar</p>
                        <div
                            className="d-flex flex-wrap justify-content-center"
                            style={{ gap: '10px', maxHeight: '250px', overflowY: 'auto' }}
                        >
                            {defaultAvatars.map((avatar) => (
                                <img
                                    key={avatar}
                                    src={avatar}
                                    alt="avatar-option"
                                    onClick={() => handleAvatarClick(avatar)}
                                    className={`img-fluid rounded-circle ${selectedAvatar === avatar ? 'border border-primary border-3' : 'border border-light'}`}
                                    style={{
                                        width: '50px',
                                        height: '50px',
                                        objectFit: 'cover',
                                        cursor: 'pointer',
                                        transition: 'border-color 0.2s'
                                    }}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Columna de Formulario de Datos */}
            <div className="col-md-8">
                <div className="card shadow-sm border-0">
                    <div className="card-body p-4">
                        <h3 className="mb-4">Editar mi Perfil</h3>
                        {error && !loading && <div className="alert alert-danger">{error}</div>}
                        {success && <div className="alert alert-success">{success}</div>}

                        <form onSubmit={handleDataSubmit}>
                            <div className="mb-3">
                                <label htmlFor="nombre_completo" className="form-label">Nombre Completo</label>
                                <input type="text" className="form-control" id="nombre_completo" name="nombre_completo" value={formData.nombre_completo} onChange={handleChange} />
                            </div>

                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Email</label>
                                <input type="email" className="form-control" id="email" name="email" value={formData.email} onChange={handleChange} disabled />
                                <small className="text-muted">El email no se puede cambiar.</small>
                            </div>

                            <div className="mb-3">
                                <label htmlFor="bio" className="form-label">Biografía Corta</label>
                                <textarea className="form-control" id="bio" name="bio" rows="3" placeholder="Habla un poco sobre ti..." value={formData.bio} onChange={handleChange}></textarea>
                            </div>

                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="universidad_id" className="form-label">Universidad</label>
                                    <select className="form-select" id="universidad_id" name="universidad_id" value={selectedUniversidadId} onChange={handleUniversidadChange} >
                                        <option value="">-- Selecciona --</option>
                                        {universidades.map((uni) => (
                                            <option key={uni.id} value={uni.id}>
                                                {uni.nombre} {uni.siglas ? `(${uni.siglas})` : ''}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="facultad_id" className="form-label">Facultad</label>
                                    <select className="form-select" id="facultad_id" name="facultad_id" value={formData.facultad_id} onChange={handleChange} disabled={!selectedUniversidadId || facultades.length === 0} >
                                        <option value="">-- Selecciona --</option>
                                        {facultades.map((fac) => (
                                            <option key={fac.id} value={fac.id}>
                                                {fac.nombre}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="carrera" className="form-label">Carrera (Opcional)</label>
                                    <input type="text" className="form-control" id="carrera" name="carrera" value={formData.carrera} onChange={handleChange} />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="telefono" className="form-label">Teléfono (Opcional)</label>
                                    <input type="tel" className="form-control" id="telefono" name="telefono" placeholder="Ej: 0981 123 456" value={formData.telefono} onChange={handleChange} />
                                </div>
                            </div>

                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading ? 'Guardando...' : 'Guardar Cambios'}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProfilePage;
